<template>
  <div class="main">
    <h2 style="text-align:center">{{detail.title}}</h2>
    <div style="margin-top:30px" v-html="detail.content">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      detail: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    getDetail() {
      this.$api.registerRules().then(res => {
        this.detail = res.data
        // console.log(res)
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail()
    this.$store.commit('setLoading', false);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.main {
  width: 70%;
  margin: 50px auto;
}
</style>
